import { render, staticRenderFns } from "./SatelliteFieldDetail.vue?vue&type=template&id=2f3458b6&scoped=true&"
import script from "./SatelliteFieldDetail.vue?vue&type=script&lang=js&"
export * from "./SatelliteFieldDetail.vue?vue&type=script&lang=js&"
import style0 from "./SatelliteFieldDetail.vue?vue&type=style&index=0&id=2f3458b6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3458b6",
  null
  
)

export default component.exports